var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWalletIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.9 12.981h-1.523L6.931 8.533v4.448H5.409v-6.49H6.93l3.446 4.457V6.49H11.9v6.49Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M0 6.589a2.92 2.92 0 0 1 2.92-2.921h11.9a2.92 2.92 0 0 1 2.92 2.92v6.491A2.92 2.92 0 0 1 14.82 16H2.92A2.92 2.92 0 0 1 0 13.08V6.588Zm2.92-1.407c-.776 0-1.406.63-1.406 1.407v6.49c0 .777.63 1.406 1.407 1.406h11.9c.776 0 1.406-.63 1.406-1.406V6.59c0-.777-.63-1.407-1.407-1.407H2.92Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.763 2.41a1.406 1.406 0 0 0-1.835-.793l-8.724 3.51-.566-1.404L11.362.212a2.92 2.92 0 0 1 3.812 1.648l.893 2.29-1.411.55-.893-2.29Z",
  clipRule: "evenodd"
})));
export default SvgWalletIcon;